import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map, Observable } from 'rxjs';
import { CompanyInfo, CompanySearchParams, SimpleCompanyRegistration } from '../interfaces';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  private readonly director: any = {};

  constructor(
    private readonly api: ApiService,
    private readonly authService: AuthService
  ) {}

  private getCompanyId() {
    try {
      return this.authService.getAuthUser().companyId;
    } catch (error) {
      return null;
    }
  }

  public getAllCompaniesWithSearchAndPagination(params: CompanySearchParams = {}): Observable<any> {
    const queryParams: string[] = [];

    if (params.companyName) {
      queryParams.push(`companyName=${params.companyName}`);
    }
    if (typeof params.hasSubscribeToAnyPlan === 'boolean') {
      queryParams.push(`hasSubscribeToAnyPlan=${params.hasSubscribeToAnyPlan}`);
    }
    if (params.planType) {
      queryParams.push(`planType=${params.planType}`);
    }
    if (typeof params.onTrialPeriod === 'boolean') {
      queryParams.push(`onTrialPeriod=${params.onTrialPeriod}`);
    }
    if (params.companyType && params.companyType !== 'BOTH') {
      queryParams.push(`companyType=${params.companyType}`);
    }
    if (params.sector) {
      queryParams.push(`sector=${params.sector}`);
    }
    if (params.subSector) {
      queryParams.push(`subSector=${params.subSector}`);
    }
    if (params.country) {
      queryParams.push(`country=${params.country}`);
    }
    if (params.companyId) {
      queryParams.push(`companyId=${params.companyId}`);
    }
    if (params.pagingState) {
      queryParams.push(`pagingState=${params.pagingState}`);
    }

    return this.api.httpGet(`/api/companies/search${queryParams.length ? `?${queryParams.join('&')}` : ''}`);
  }

  public updateCompany(companyId, company: any): Observable<any> {
    const url = `/api/companies/${companyId}`;
    return this.api.httpPut(url, company);
  }

  public registerAdvertiserCompany(data: SimpleCompanyRegistration): Observable<CompanyInfo> {
    return this.api.httpPost('/api/companies/register/advertiser', data).pipe(map((res: any) => res as CompanyInfo));
  }

  public getCompanyById(companyId): Observable<any> {
    return this.api.httpGet(`/api/companies/${companyId}`);
  }

  public getCompanyUsers(includeBrandId: boolean = false): Observable<any> {
    const params = includeBrandId ? '?includeBrandId=true' : '';
    return this.api.httpGet(`/api/users/company/${this.getCompanyId()}${params}`);
  }

  //this is only for admin
  updateCompanyAccess(companyId: string, access: any) {
    return this.api.httpPut(`/api/admin/company-access/${companyId}`, access);
  }

  forceDeleteCompanies(companyIds: string[]) {
    return this.api.httpDelete(`/api/admin/deleteCompanyForceMulti`, companyIds);
  }
}
